import { useWorkflowMetadataByTrackingReference } from '../../WorkflowMetadataContext/useWorkflowMetadataByTrackingReference';

/**
 * The client of a journey resumed with no tracking reference (no invite in this session), read
 * by the caller from the customer's requests. The workflow metadata needs a tracking reference.
 */
export type TConfirmEntityClient = { organisationId: string; organisationName?: string };

/**
 * The client the confirm screen is for. With no tracking reference, the client the caller gives
 * stands in for the workflow metadata (no logo, nothing to load); otherwise the metadata of the
 * tracking reference gives it.
 */
export function useConfirmClient(
  trackingReference: string | undefined,
  client: TConfirmEntityClient | undefined,
) {
  const fromMetadata = useWorkflowMetadataByTrackingReference(trackingReference);
  if (!trackingReference && client) {
    return {
      organisationId: client.organisationId,
      organisationName: client.organisationName,
      metadata: undefined,
      isLoading: false,
      hasError: false,
    };
  }
  return {
    organisationId: fromMetadata.organisationId,
    organisationName: fromMetadata.organisationName,
    metadata: fromMetadata.metadata,
    isLoading: fromMetadata.isLoading,
    hasError: fromMetadata.error,
  };
}
